import { useTranslation } from "react-i18next"
import { useDeleteContractModelMutation, useGetContractModelsQuery } from "./api/workContractApiSlice"
import PageLayout from "components/layout/PageLayout"
import ContractModelCard from "./components/ContractModelCard"
import NewContractModelModal from "./components/NewContractModelModal"
import NoData from "components/commons/NoData"

const ManageContractModel = () => {

    const [t, i18n] = useTranslation(["global, absenceReport"])

    const {
        data: contractModels,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetContractModelsQuery()


    const [
        deleteContractModel, {
            isLoading: deleteIsLoading,
            isSuccess: deleteIsSuccess
        }
    ] = useDeleteContractModelMutation()

    let content

    if (isSuccess)
        content =
            <>
                <div className="mb-4"><NewContractModelModal /></div>
                {contractModels.map(model => {
                    return <ContractModelCard key={model.guid} contractModel={model} onDelete={deleteContractModel} />
                })}
                {contractModels.length == 0 && <NoData />}
            </>


    return <PageLayout
        pageTitle={t("absenceReport:menu.contracts")}
        isLoadingPage={isLoading}
        isLoadingContent={isFetching}
        onPageRefresh={refetch}
        bodyContent={content}
    />

}

export default ManageContractModel